/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Current_Pain_NoInputs */

const en_us2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pain right now`)
};

const pt_br2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dor no momento`)
};

const es_419_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin dolor por ahora`)
};

const pt_pt2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem dor neste momento`)
};

const fr_fr2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de douleur en ce moment`)
};

const de_de2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade keine Schmerzen`)
};

const it_it2_onboarding_current_pain_no = /** @type {(inputs: Onboarding_Current_Pain_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dolore adesso`)
};

/**
* | output |
* | --- |
* | "No pain right now" |
*
* @param {Onboarding_Current_Pain_NoInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_current_pain_no = /** @type {((inputs?: Onboarding_Current_Pain_NoInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Current_Pain_NoInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_current_pain_no(inputs)
	if (locale === "es-419") return es_419_onboarding_current_pain_no(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_current_pain_no(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_current_pain_no(inputs)
	if (locale === "de-DE") return de_de2_onboarding_current_pain_no(inputs)
	if (locale === "it-IT") return it_it2_onboarding_current_pain_no(inputs)
	return en_us2_onboarding_current_pain_no(inputs)
});
export { onboarding_current_pain_no as "onboarding.current_pain.no" }